export enum NarrativeStatusTypes {
  new = 'new',
  pre_mapped = 'pre_mapped',
  shallow_mapped = 'shallow_mapped',
  fully_mapped = 'fully_mapped',
}
